const resources = {
    new: 'New'
};

module.exports = function getResource(label) {
    return resources[label];
};
